import { render, staticRenderFns } from "./paymentCheck.vue?vue&type=template&id=50625b21&"
import script from "./paymentCheck.vue?vue&type=script&lang=js&"
export * from "./paymentCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports